export class Ads {
  id: number;
  type: number;
  description: string;
  createAt: string;
  images: string;
  showAds: boolean;
  shortDate: string;
  active: number;
  deleted: number;
}
